import { Controller, useForm } from 'react-hook-form'
import { ErrorMessage } from "@hookform/error-message";

import { Box, Button, Checkbox, Grid, MenuItem, Stack, TextField, CheckBox, Alert } from '@mui/material'



const UserForm = (props) => {

    const initValues = {
      tenantid: props.tenant[0].id,
      familyname: '',
      lastname: '',
      uid: '',
      mailaddress: '',
    }

    const data = {
      ...initValues,
      ...props.data,
    }

     const {tenantid,familyname,lastname,uid,email} = data;


  const { register, handleSubmit, control,setValue,defaultValues, formState: { errors } } = useForm({
    defaultValues: {familyname: familyname,lastname: lastname,uid:uid,email:email
    }});

  const onSubmit = (row) => {
    // data.type = editable ? "update" : "create";
    const tname = props.tenant.find( (item) => {
      return row.tenantid == item.id;
    });
    const newData = {
      ...props.data,
      ...row,
      tenantname: tname.name,
    };

    console.log(newData);

    props.process(newData);
  };

  const cancel = () => {
    props.cancel();
  }

  return (
    <>
      <Grid container sx={{ml:1,mt:2,mb:2,mr:2 }}>
        <Grid item xs={10}>
          <TextField
              label="テナント"
              select
              sx={{width: 200}}
              defaultValue={tenantid}
              {...register("tenantid", {
                required: true
              })}
          >
            {props.tenant.map((item) => {
              return (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
              )
            })}
          </TextField>
        </Grid>
        <Grid item xs={5}>
          <Controller
            name="familyname"
            control={control}
            rules={{ required: true}}
            render={({ field }) => <TextField
              label="姓"
              fullWidth
              sx={{mb:1}}
              size="small"
              {...field}
            />
              }
          />
          {errors.familyname?.type === 'required' && <Alert sx={{width:'90%'}} severity="warning">
            姓は必須です！
          </Alert>}
          </Grid>
          <Grid item xs={5} >
        <TextField
          label="名"
          fullWidth
          sx={{mb:1,ml:1,mr:1}}
          {...register("lastname", {
            required: true
          })}
          size="small"
        />
            {errors.lastname?.type === 'required' && <Alert sx={{width:'90%'}} severity="warning">
              名は必須です！
            </Alert>}
          </Grid>
        <Grid item xs={10}>
          <TextField
            label="ユーザID"
            fullWidth
            sx={{mb:1}}
            {...register("uid", {
              required: true,
              pattern: {
                value: /^[A-Z0-9._%-]+$/i,
              },
            })}
            size="small"
          />
          {errors.uid?.type === 'required' && <Alert sx={{width:'90%'}} severity="warning">
            ユーザIDは必須です！
          </Alert>}
          {errors.uid?.type === 'pattern' && <Alert sx={{width:'100%'}} severity="warning">
            ユーザIDに使える文字は英文字、数字 - _ .  %のみです。
          </Alert>}
        </Grid>
        <Grid item xs={10} >
          <TextField
            label="Eメール"
            fullWidth
            sx={{mb:1}}
            {...register("email", {
              required: true,
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              },
            })}
            size="small"
          />
          {errors.email?.type === 'required' && <Alert sx={{width:'90%'}} severity="warning">
            Eメールは必須です！
          </Alert>}
          {errors.email?.type === 'pattern' && <Alert sx={{width:'100%'}} severity="warning">
           メールの形式が不正です。
          </Alert>}
        </Grid>

        <Grid item xs={10} >
          <Box sx={{ml:35}}>
            <Button variant="contained" onClick={handleSubmit(onSubmit)}>登録</Button>
            <Button sx={{ml:1}} variant="outlined" onClick={cancel}>キャンセル</Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );

};

export default UserForm;